import { useSearch, useNavigate } from '@tanstack/react-router';
import { motion } from 'motion/react';
import { QuizletList } from './QuizletList';
import { DeckGroupList } from './DeckGroupList';
import styles from './QuizletsPage.module.scss';

type Tab = 'decks' | 'grouped';

export function QuizletsPage() {
  const search = useSearch({ from: '/quizlets/' });
  const navigate = useNavigate();
  const activeTab: Tab = (search as any)?.tab === 'grouped' ? 'grouped' : 'decks';

  const handleTabChange = (tab: Tab) => {
    navigate({
      to: '/quizlets',
      search: { tab },
    });
  };

  return (
    <div className={styles.quizletsPage}>
      <div className={styles.quizletsPage__tabs}>
        <button
          className={`${styles.quizletsPage__tab} ${activeTab === 'decks' ? styles['quizletsPage__tab--active'] : ''}`}
          onClick={() => handleTabChange('decks')}
        >
          Decks
        </button>
        <button
          className={`${styles.quizletsPage__tab} ${activeTab === 'grouped' ? styles['quizletsPage__tab--active'] : ''}`}
          onClick={() => handleTabChange('grouped')}
        >
          Grouped Decks
        </button>
      </div>

      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2 }}
      >
        {activeTab === 'decks' ? <QuizletList /> : <DeckGroupList />}
      </motion.div>
    </div>
  );
}
